import {
  CONSENT_TYPES,
  type ConsentAction,
  type ConsentSource,
  type ConsentType,
} from '../dataProvider/types';

/** Display vocabulary for the consent-records surface (D-consent-records, Phase 7 surface 2). */

export const CONSENT_TYPE_LABEL: Record<ConsentType, string> = {
  marketing_email: 'Marketing email',
  marketing_push: 'Marketing push',
  data_processing: 'Data processing',
  cookies: 'Cookies',
  third_party_sharing: 'Third party sharing',
  age_confirmation: 'Age confirmation',
};

export const CONSENT_ACTION_LABEL: Record<ConsentAction, string> = {
  grant: 'Granted',
  revoke: 'Revoked',
};

export const CONSENT_ACTION_COLOR: Record<
  ConsentAction,
  'success' | 'default'
> = {
  grant: 'success',
  revoke: 'default',
};

export const CONSENT_SOURCE_LABEL: Record<ConsentSource, string> = {
  signup: 'Signup',
  settings: 'App settings',
  consumer_app: 'Consumer app',
  compliance_logged: 'Recorded by compliance',
};

/**
 * The consent types offered to the off-app withdrawal action. ALL types: a member may withdraw
 * any consent off-app. The action only ever appends a `revoke`, so the list is the full
 * vocabulary, not a granted-only subset (recording a revoke for an already-revoked type is a
 * harmless no-op on the derived state).
 */
export const WITHDRAWABLE_CONSENT_OPTIONS: readonly {
  value: ConsentType;
  label: string;
}[] = CONSENT_TYPES.map((value) => ({
  value,
  label: CONSENT_TYPE_LABEL[value],
}));
